var _path, _mask, _g, _mask2, _g2, _rect, _path2, _path3, _circle, _path4, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewGoverningDocuments = function SvgViewGoverningDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 661 576",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M0 0h661v576H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-governing-documents_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M255 0h406v307H255z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-governing-documents_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M817.813 181.482H468.864A129.192 129.192 0 01598.051 52.351H947a129.192 129.192 0 01-129.187 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M630.511 129.131H281.565A129.193 129.193 0 01410.755 0h348.946a129.18 129.18 0 01-129.19 129.131zM520.014 292H359.51a129.195 129.195 0 0137.853-91.31 129.17 129.17 0 0191.316-37.821h160.504a129.182 129.182 0 01-37.85 91.312A129.163 129.163 0 01520.014 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-governing-documents_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M0 292h463.099v284H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-governing-documents_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M206.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C271.533 562.928 239.889 576 206.894 576zM40.252 434h-337.045c.013-32.915 13.166-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.218-36.342h337.035a123.527 123.527 0 01-9.502 47.495 124.062 124.062 0 01-27.049 40.261 124.793 124.793 0 01-40.48 26.897A125.31 125.31 0 0140.252 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M302.641 496.685H47.333c.013-32.915 13.157-64.478 36.541-87.748 23.384-23.27 55.094-36.342 88.157-36.342h255.248a123.512 123.512 0 01-9.466 47.497 123.969 123.969 0 01-27.015 40.268 124.606 124.606 0 01-40.447 26.898 125.055 125.055 0 01-47.71 9.427z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 202,
    width: 277,
    height: 164,
    rx: 5,
    fill: "#2C3E50",
    stroke: "#fff",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348 369h-34v21h-43v7h120v-7h-43v-21z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372.004 248h-43.889c-3.827 0-6.914 3.069-6.914 6.875v7.167H287.05c-3.828 0-6.915 3.069-6.915 6.876v42.311c0 3.806 3.087 6.876 6.915 6.876h84.954c3.828 0 6.915-3.07 6.915-6.876v-56.354c0-3.806-3.087-6.875-6.915-6.875z",
    fill: "#959EA7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 375.432,
    cy: 316.568,
    r: 17.432,
    fill: "#33BB40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.8 312.911l5.944-5.074 5.944 5.074H369.8zm3.128 0h5.632v6.944h-5.632v-6.944zm-4.38 8.821a1.25 1.25 0 100 2.502h15.017a1.251 1.251 0 100-2.502h-15.017zM331.716 271.057a1.366 1.366 0 00.194 1.922l7.402 6.049a1.366 1.366 0 001.728-2.115l-7.402-6.049a1.366 1.366 0 00-1.922.193zm-1.728 2.115l-12.099 14.804 9.517 7.778 12.099-14.804-9.517-7.778zm5.196 13.065l-3.457 4.23 19.033 15.555 3.457-4.23-19.033-15.555zm-18.83 5.775a1.365 1.365 0 111.729-2.114l7.402 6.049a1.366 1.366 0 01-1.729 2.115l-7.402-6.05z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 309.486,
    y: 302.541,
    width: 17.432,
    height: 2.324,
    rx: 1.162,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 306.027,
    width: 24.405,
    height: 2.324,
    rx: 1.162,
    fill: "#fff"
  })));
};

export default SvgViewGoverningDocuments;